import { DocumentIsogd } from 'isogd-document-rest';

class DocumentApproveEditController {

    private document: DocumentIsogd;
    private selectedDocumentOrg:  any;
    private documentOrgs: any[];
    private approvedocTypes: any[];
    private selectedApprovedocType: any;

    changeDocumentOrganization() {
        this.document.approveDocument.approveOrganizationCode = undefined;
        this.selectedDocumentOrg = undefined
    }

    onDocumentOrgChange() {
        this.document.approveDocument.approveOrganization = this.selectedDocumentOrg.shortName;
        this.document.approveDocument.approveOrganizationCode = this.selectedDocumentOrg.orgCode;
    }

    onApproveDocumentTypeChange() {
        this.document.approveDocument.approveDocumentValue = this.selectedApprovedocType.approvedocName;
        this.document.approveDocument.approveDocumentType = this.selectedApprovedocType.approvedocCode;
    }
}

export const DocumentApproveEditComponent: angular.IComponentOptions = {
    controller: DocumentApproveEditController,
    template: require('./documentApproveEdit.html'),
    bindings: {
        document: "<",
        selectedDocumentOrg: "<",
        documentOrgs: "<",
        approvedocTypes: "<",
        selectedApprovedocType: "<"
    }
};


// WEBPACK FOOTER //
// ./src/components/document/document-approve/documentApproveEdit.ts